import React from "react";
import Chip from "@mui/joy/Chip";
import type { StatusColor } from "../canvasStyleOverrides";

/** The colour for a status value: exact match, then case-insensitive, else neutral. */
export function statusColorFor(
  value: string,
  statusColors: Record<string, StatusColor> | undefined,
): StatusColor {
  if (!statusColors) return "neutral";
  if (Object.prototype.hasOwnProperty.call(statusColors, value)) {
    return statusColors[value];
  }
  const lower = value.trim().toLowerCase();
  const key = Object.keys(statusColors).find(
    (candidate) => candidate.trim().toLowerCase() === lower,
  );
  return key ? statusColors[key] : "neutral";
}

/** A status value as a soft coloured pill (Joy Chip). Renders nothing for an empty value. */
export default function StatusChip({
  value,
  statusColors,
}: {
  value: string;
  statusColors?: Record<string, StatusColor>;
}) {
  if (!value) return null;
  const color = statusColorFor(value, statusColors);
  return (
    <span
      data-testid="status-chip"
      data-status-color={color}
      style={{ display: "inline-flex" }}
    >
      <Chip size="sm" variant="soft" color={color}>
        {value}
      </Chip>
    </span>
  );
}
